import {
  type IPatient,
  PatientStatus,
} from '@principle-theorem/principle-core/interfaces';
import {
  BaseExistingPatientDestinationEntity,
  IExistingPatientMergeConflictSummary,
} from '../../../destination/entities/existing-patient';
import {
  OasisPatient,
  PatientSourceEntity,
} from '../../source/entities/patients';
import { WithRef } from '@principle-theorem/shared';
import { getName, getPhone } from './patients';
import { IGetRecordResponse } from '@principle-theorem/practice-migrations/interfaces';

export class ExistingPatientDestinationEntity extends BaseExistingPatientDestinationEntity<OasisPatient> {
  patientSourceEntity = new PatientSourceEntity();

  override sourceEntities = {
    patients: this.patientSourceEntity,
  };

  getDateOfBirth(
    sourcePatient: IGetRecordResponse<OasisPatient>
  ): string | undefined {
    return sourcePatient.data.dateOfBirth;
  }

  filterMatchingPatients(
    sourcePatient: IGetRecordResponse<OasisPatient>,
    matchingPatients: WithRef<IPatient>[]
  ): WithRef<IPatient>[] {
    return matchingPatients.filter(
      (patient) =>
        [sourcePatient.data.firstName, sourcePatient.data.lastName].every(
          (name) => patient.name.toLowerCase().includes(name.toLowerCase())
        ) && patient.status === PatientStatus.Active
    );
  }

  buildConflictSummary(
    sourcePatient: OasisPatient
  ): Omit<IExistingPatientMergeConflictSummary, 'status' | 'patientRefs'> {
    const sourcePatientId = this.patientSourceEntity
      .getSourceRecordId(sourcePatient.data)
      .toString();

    return {
      sourcePatientId,
      patientName: getName(sourcePatient.data),
      dateOfBirth: sourcePatient.data.dateOfBirth ?? '',
      gender: sourcePatient.data.gender,
      phone: getPhone(sourcePatient.data),
      email: sourcePatient.data.email ?? '',
    };
  }
}
